import type { RadioProps } from './Radio';
import type { RadioGroupProps, RadioGroupVariant } from './RadioGroup';

export type RadioItemType = RadioGroupVariant;

export type OldRadioProps = Omit<RadioProps, 'variant'> & {
  /** @deprecated variant를 대신 사용해주세요. */
  radioItemType?: RadioGroupVariant;
};

export function convertOldRadioProps(props: OldRadioProps): RadioProps {
  const { radioItemType, ...restProps } = props;

  return {
    ...restProps,
    variant: radioItemType,
  };
}

export type OldRadioGroupProps<RadioValue> = Omit<RadioGroupProps<RadioValue>, 'variant'> & {
  /** @deprecated variant를 대신 사용해주세요. */
  radioItemType?: RadioGroupVariant;
};

export function convertOldRadioGroupProps<RadioValue>(
  props: OldRadioGroupProps<RadioValue>,
): RadioGroupProps<RadioValue> {
  const { radioItemType, ...restProps } = props;

  return {
    ...restProps,
    variant: radioItemType,
  };
}
